const importStripe = (onLoadCallback = () => {}) => {
  if (window.Stripe) return onLoadCallback()

  const stripeJS = document.createElement('script')

  stripeJS.src = 'https://js.stripe.com/v3/'
  stripeJS.id = 'stripe-js-script'

  if (onLoadCallback) stripeJS.onload = onLoadCallback

  document.head.appendChild(stripeJS)
}

const importPlaid = (onLoadCallback = () => {}) => {
  if (window.Plaid) return onLoadCallback()

  const plaidJS = document.createElement('script')

  plaidJS.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js'
  plaidJS.id = 'plaid-js-script'

  if (onLoadCallback) plaidJS.onload = onLoadCallback

  document.head.appendChild(plaidJS)
}

const importGoogleMaps = (onLoadCallback = () => {}) => {
  if (window.google && window.google.maps) return onLoadCallback()

  const googleMaps = document.createElement('script')
  const apiKey = process.env.VUE_APP_GMAPS_API_KEY

  googleMaps.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`
  googleMaps.id = 'google-maps-script'

  if (onLoadCallback) googleMaps.onload = onLoadCallback

  document.head.appendChild(googleMaps)
}

// When using this, make sure to call this in the components mounted lifecycle hook
const importYotpo = () => {
  // if Yotpo has already been loaded, refresh the widgets
  if (window.yotpo) return window.yotpo.refreshWidgets()

  const yotpoScript = document.createElement('script')

  yotpoScript.id = 'yotpo-script'
  yotpoScript.type = 'text/javascript'
  yotpoScript.async = true
  yotpoScript.src = `//staticw2.yotpo.com/${process.env.VUE_APP_YOTPO_APP_ID}/widget.js`
  document.head.appendChild(yotpoScript)
}

// When using this, make sure to call this in the components mounted lifecycle hook
const importOmniCalculator = () => {
  // if Yotpo has already been loaded, refresh the widgets
  const existingOmniScript = document.getElementById('omnicalculator-script')
  if (existingOmniScript) {
    existingOmniScript.remove()
    delete window.OmniC
  }
  const omniScript = document.createElement('script')

  omniScript.id = 'omnicalculator-script'
  omniScript.type = 'text/javascript'
  omniScript.src = `https://cdn.omnicalculator.com/sdk.js?ts=${Date.now()}`
  document.head.appendChild(omniScript)
}

const importZendeskChat = (settings, onLoadCallback = () => {}) => {
  const existingZendeskChat = document.getElementById('zendesk-chat-script')

  if (existingZendeskChat) {
    existingZendeskChat.remove()
    delete window.zE
    delete window.zESettings
  }

  window.zESettings = settings

  const zendeskScript = document.createElement('script')

  // This has to be called `ze-snippet` so the script works.
  zendeskScript.id = 'ze-snippet'
  zendeskScript.type = 'text/javascript'
  zendeskScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${process.env.VUE_APP_ZENDESK_CHAT_WIDGET_KEY}`
  zendeskScript.async = true

  if (onLoadCallback) zendeskScript.onload = onLoadCallback

  document.head.appendChild(zendeskScript)
}

const importMapboxGeocoder = (onLoadCallback = () => {}) => {
  const SCRIPT_ID = 'mapbox-geo-script'
  const STYLE_ID = 'mapbox-geo-style'

  if (document.querySelector(`#${SCRIPT_ID}`)) {
    return onLoadCallback()
  } else {
    const mapboxGeocoderJS = document.createElement('script')
    mapboxGeocoderJS.src =
      'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.min.js'
    mapboxGeocoderJS.id = SCRIPT_ID
    mapboxGeocoderJS.onload = onLoadCallback
    mapboxGeocoderJS.onerror = () => {
      console.error('Failed to load Mapbox Geocoder JS.')
    }
    mapboxGeocoderJS.defer = true
    document.head.appendChild(mapboxGeocoderJS)
  }

  if (!document.querySelector(`#${STYLE_ID}`)) {
    const mapboxGeocoderCSS = document.createElement('link')
    mapboxGeocoderCSS.rel = 'stylesheet'
    mapboxGeocoderCSS.type = 'text/css'
    mapboxGeocoderCSS.id = STYLE_ID
    mapboxGeocoderCSS.href =
      'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.css'
    mapboxGeocoderCSS.onerror = () => {
      console.error('Failed to load Mapbox Geocoder CSS.')
    }
    document.head.appendChild(mapboxGeocoderCSS)
  }
}

const importBaseMapbox = (onJSLoadCallback = () => {}, onCSSLoadCallback = () => {}) => {
  const SCRIPT_ID = 'mapbox-base-script'
  const STYLE_ID = 'mapbox-base-style'

  if (document.querySelector(`#${STYLE_ID}`)) {
    onCSSLoadCallback()
  } else {
    const mapboxCSS = document.createElement('link')
    mapboxCSS.rel = 'stylesheet'
    mapboxCSS.type = 'text/css'
    mapboxCSS.id = STYLE_ID
    mapboxCSS.href = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css'
    mapboxCSS.onload = onCSSLoadCallback
    mapboxCSS.onerror = () => {
      console.error('Failed to load Mapbox CSS.')
    }
    document.head.appendChild(mapboxCSS)
  }

  if (document.querySelector(`#${SCRIPT_ID}`)) {
    onJSLoadCallback()
  } else {
    const mapboxScript = document.createElement('script')
    mapboxScript.src = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.js'
    mapboxScript.id = SCRIPT_ID
    mapboxScript.onload = onJSLoadCallback
    mapboxScript.onerror = () => {
      console.error('Failed to load Mapbox JS.')
    }
    mapboxScript.defer = true
    document.head.appendChild(mapboxScript)
  }
}

export {
  importGoogleMaps,
  importYotpo,
  importStripe,
  importPlaid,
  importOmniCalculator,
  importZendeskChat,
  importMapboxGeocoder,
  importBaseMapbox,
}
